// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"H3Ncxbew","primary":"kjWAnUK7"};
    if(module.hot) {
      // 1776432169959
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  